import { BAFTA_FUND_SLUG, User } from "@ecologi/shared";
import { useRouter } from "next/router";
import { TuftyButton } from "../../Button/TuftyButton";

type Props = {
  isOwnProfile: boolean;
  isBulkParent?: boolean;
  user?: User | null;
  username?: string;
};

const buildImpactShopUrl = (path: string, username?: string): string => {
  const params = new URLSearchParams({
    utm_source: "Profiles",
    utm_medium: "FundImpactCTA",
    ...(username ? { utm_content: username } : {}),
  });
  return `${path}?${params.toString()}`;
};

export const BuyMoreImpactButton = ({
  isOwnProfile,
  isBulkParent,
  username,
}: Props) => {
  const router = useRouter();

  return (
    <TuftyButton
      primary
      extra={{
        style: {
          display: "block",
          margin: "15px auto 0",
        },
      }}
      onClick={(e) => {
        e.preventDefault();
        if (e.currentTarget instanceof HTMLElement) {
          e.currentTarget.blur();
        }

        if (isOwnProfile && isBulkParent) {
          router.push(
            buildImpactShopUrl(`/impact-shop/${BAFTA_FUND_SLUG}`, username)
          );
          return;
        }
        router.push(buildImpactShopUrl("/impact-shop", username));
      }}
      text={isOwnProfile ? "Buy more impact" : "Fund impact"}
    />
  );
};
